import { render, staticRenderFns } from "./FileUploadPop.vue?vue&type=template&id=2820cb3a&scoped=true&"
import script from "./FileUploadPop.vue?vue&type=script&lang=js&"
export * from "./FileUploadPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820cb3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
